// 城市生育津贴补差政策服务
export interface CityPolicy {
  cityName: string
  policyTitle: string
  baseSalary: boolean  // 是否在产假期间发放工资
  declaredSalary?: boolean  // 是否显示单位申报月平均工资，默认false
}

// 城市政策数据
const cityPolicies: { [key: string]: CityPolicy } = {
  'shanghai': {
    cityName: '上海市',
    policyTitle: '上海市生育津贴补差政策',
    baseSalary: false,
    declaredSalary: true
  },
  'guangzhou': {
    cityName: '广东省广州市',
    policyTitle: '广东省生育津贴补差政策',
    baseSalary: false
  },
  'shenzhen': {
    cityName: '广东省深圳市',
    policyTitle: '深圳市生育津贴补差政策',
    baseSalary: true
  },
  'beijing': {
    cityName: '北京市',
    policyTitle: '北京市生育津贴补差政策',
    baseSalary: false
  },
  'tianjin': {
    cityName: '天津市',
    policyTitle: '天津市生育津贴补差政策',
    baseSalary: false
  },
  'xiamen': {
    cityName: '福建省厦门市',
    policyTitle: '厦门市生育津贴补差政策',
    baseSalary: false
  },
  'chengdu': {
    cityName: '四川省成都市',
    policyTitle: '成都市生育津贴补差政策',
    baseSalary: false
  },
  'suzhou': {
    cityName: '江苏省苏州市',
    policyTitle: '苏州市生育津贴补差政策',
    baseSalary: false
  },
  'qingdao': {
    cityName: '山东省青岛市',
    policyTitle: '青岛市生育津贴补差政策',
    baseSalary: false
  },
  'chongqing': {
    cityName: '重庆市',
    policyTitle: '重庆市生育津贴补差政策',
    baseSalary: false
  },
  'zhuhai': {
    cityName: '广东省珠海市',
    policyTitle: '珠海市生育津贴补差政策',
    baseSalary: false
  },
  'foshan': {
    cityName: '广东省佛山市',
    policyTitle: '佛山市生育津贴补差政策',
    baseSalary: false
  },
  'wuhan': {
    cityName: '湖北省武汉市',
    policyTitle: '武汉市生育津贴补差政策',
    baseSalary: false
  },
  'shaoxing': {
    cityName: '浙江省绍兴市',
    policyTitle: '绍兴市生育津贴补差政策',
    baseSalary: false
  }
}

// 默认城市政策模板
const getDefaultCityPolicy = (cityName: string): CityPolicy => {
  return {
    cityName: cityName,
    policyTitle: `${cityName}生育津贴补差政策`,
    baseSalary: false  // 默认不发放工资
  }
}

// 城市代码映射表 - 将大写城市代码映射到政策配置的小写键名
const cityCodeMapping: { [key: string]: string } = {
  'SH': 'shanghai',
  'GZ': 'guangzhou', 
  'SZ': 'shenzhen',
  'BJ': 'beijing',
  'TJ': 'tianjin',
  'XM': 'xiamen',
  'CD': 'chengdu',
  'SZ2': 'suzhou',
  'QD': 'qingdao',
  'CQ': 'chongqing',
  'ZH': 'zhuhai',
  'FS': 'foshan',
  'WH': 'wuhan',
  'SX': 'shaoxing'
}

// 获取城市政策信息
export const getCityPolicy = (cityCode: string): CityPolicy | null => {
  // 首先尝试直接匹配
  let policy = cityPolicies[cityCode]
  if (policy) {
    return policy
  }
  
  // 尝试通过城市代码映射查找
  const mappedCode = cityCodeMapping[cityCode]
  if (mappedCode) {
    policy = cityPolicies[mappedCode]
    if (policy) {
      return policy
    }
  }
  
  // 尝试小写匹配
  const lowerCaseCode = cityCode.toLowerCase()
  policy = cityPolicies[lowerCaseCode]
  if (policy) {
    return policy
  }
  
  // 为未知城市提供默认政策
  const cityName = cityCode.charAt(0).toUpperCase() + cityCode.slice(1)
  return getDefaultCityPolicy(cityName)
}

// 模拟异步API调用
export const fetchCityPolicy = async (cityCode: string): Promise<CityPolicy | null> => {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 100))
  return getCityPolicy(cityCode)
}
